import { render, staticRenderFns } from "./outsource_detail.vue?vue&type=template&id=210f62ce&scoped=true"
import script from "./outsource_detail.vue?vue&type=script&lang=js"
export * from "./outsource_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210f62ce",
  null
  
)

export default component.exports